/** Shared react-hook-form + zod + i18n plumbing. */
import type { FieldValues, Path, UseFormSetError } from "react-hook-form";
import type { TFunction } from "i18next";

/** Zod messages in this app are i18n keys; translate before rendering. */
export function translateError(
  key: string | undefined,
  t: TFunction,
): string | undefined {
  return key ? t(key) : undefined;
}

/** Map a §24.2 `fields` object onto form fields ("owner.email" → nested path). */
export function applyServerFields<T extends FieldValues>(
  setError: UseFormSetError<T>,
  fields: Record<string, string> | undefined,
): void {
  if (!fields) return;
  for (const [path, message] of Object.entries(fields)) {
    setError(path as Path<T>, { message });
  }
}
